import { createContext } from 'react';

const SeoPageContext = createContext();

export default SeoPageContext;
